// 16px icons
import Plus16 from './16/plus.svg?react'
import Search16 from './16/search.svg?react'
import DotsVertical16 from './16/dots-vertical.svg?react'
import ChevronUp16 from './16/chevron-up.svg?react'
import ChevronDown16 from './16/chevron-down.svg?react'
import UserCircle16 from './16/user-circle.svg?react'
import ShieldCheck16 from './16/shield.svg?react'
import Bulb16 from './16/bulb.svg?react'
import Logout16 from './16/logout.svg?react'
import Menu16 from './16/menu.svg?react'
import X16 from './16/x.svg?react'
import ArrowDown16 from './16/downArrow.svg?react'
import SwitchVertical16 from './16/switch-vertical.svg?react'
import CodeDesignBrandIcon16 from './16/CodeDesign-brand-lcon.svg?react'
import WordpressIcon16 from './16/wordpress.svg?react'
import SixDots16 from './16/6dots.svg?react'
import Sparkle16 from './16/sparkle.svg?react'
import SparkleWhite16 from './16/sparkleWhite.svg?react'
import LastUpdated16 from './16/lastUpdated.svg?react'
import Crown16 from './16/crown.svg?react'
import CheckBadge16 from './16/checkbadge.svg?react'
import GoogleIcon16 from './16/google.svg?react'
import EyeIcon16 from './16/eye.svg?react'
import CrossIcon16 from './16/cross.svg?react'
import EditIcon16 from './16/edit.svg?react'
import GlobeIcon16 from './16/globe.svg?react'
import MoreIcon16 from './16/more.svg?react'
import DevicesIcon16 from './16/devices.svg?react'
import CookieLogoIcon from './18/cookie.svg?react'

// 20px icons
import Plus20 from './20/plus.svg?react'
import GreenTick20 from './20/greenTick.svg?react'
import FileText20 from './20/file-text.svg?react'
import ChartBar20 from './20/chart-bar.svg?react'
import Eye20 from './20/eye.svg?react'
import Home20 from './20/home.svg?react'
import Users20 from './20/users.svg?react'
import Copy20 from './20/copy.svg?react'
import CreditCard20 from './20/credit-card.svg?react'
import Settings20 from './20/settings.svg?react'
import School20 from './20/school.svg?react'
import News20 from './20/news.svg?react'
import Puzzle20 from './20/puzzle.svg?react'
import Layout20 from './20/layout.svg?react'
import MessageCircle20 from './20/message-circle.svg?react'
import Photo20 from './20/photo.svg?react'
import CPU20 from './20/cpu.svg?react'
import Globe20 from './20/globe.svg?react'
import Bell20 from './20/bell.svg?react'
import trello20 from './20/trello.svg?react'
import zapier20 from './20/zapier.svg?react'
import stripe20 from './20/stripe.svg?react'
import slack20 from './20/slack.svg?react'
import airtable20 from './20/airtable.svg?react'
import notion20 from './20/notion.svg?react'
import gmail20 from './20/gmail.svg?react'
import gsheet20 from './20/gsheet.svg?react'
import wordpress20 from './20/wordpress.svg?react'
import EmptyState20 from './20/empty.svg?react'
import Refresh20 from './20/refresh.svg?react'
import BarChart20 from './20/chart-bar.svg?react'
import CodeBracket20 from './20/code-bracket.svg?react'
import BrandGoogle20 from './20/brand-google.svg?react'
import BrandGoogleG20 from './20/brand-google-g.svg?react'
import BrandX20 from './20/brand-x.svg?react'
import BrandFacebook20 from './20/brand-facebook.svg?react'
import FormBuilder20 from './20/form-builder.svg?react'

// 24px icons
import AIWebsiteBuilder24 from './24/ai-website-builder.svg?react'
import AIWritingTools24 from './24/ai-writing-tools.svg?react'
import AIWebsiteLibrary24 from './24/ai-website-library.svg?react'
import DraftGenerations24 from './24/draft-generations.svg?react'
import SeoAudit24 from './24/seo-audit.svg?react'
import GoogleCalendar24 from './24/google_calendar.svg?react'
import GoogleMeet24 from './24/google_meet.svg?react'
import MicrosoftOutlook24 from './24/microsoft_outlook.svg?react'
import MicrosoftTeams24 from './24/microsoft_teams.svg?react'
import Zoom24 from './24/zoom.svg?react'
import Branch24 from './24/branch.svg?react'

//imgs manipulated
import DefaultFavicon from '../images/defaultfavicon.svg?react'


// Export 16px icons
export {
    Plus16,
    Search16,
    DotsVertical16,
    ChevronUp16,
    ChevronDown16,
    UserCircle16,
    ShieldCheck16,
    Bulb16,
    Logout16,
    Menu16,
    X16,
    ArrowDown16,
    SwitchVertical16,
    CodeDesignBrandIcon16,
    WordpressIcon16,
    SixDots16,
    Sparkle16,
    Crown16,
    CheckBadge16,
    GoogleIcon16,
    SparkleWhite16,
    LastUpdated16,
    EyeIcon16,
    CrossIcon16,
    EditIcon16,
    GlobeIcon16,
    MoreIcon16,
    DevicesIcon16,
    CookieLogoIcon,
}

// Export 20px icons
export {
    Plus20,
    FileText20,
    ChartBar20,
    Eye20,
    Home20,
    Users20,
    Copy20,
    CreditCard20,
    Settings20,
    School20,
    News20,
    Puzzle20,
    Layout20,
    MessageCircle20,
    Photo20,
    CPU20,
    Globe20,
    Bell20,
    trello20,
    zapier20,
    stripe20,
    slack20,
    airtable20,
    notion20,
    gmail20,
    gsheet20,
    wordpress20,
    EmptyState20,
    GreenTick20,
    Refresh20,
    BarChart20,
    CodeBracket20,
    BrandGoogle20,
    BrandGoogleG20,
    BrandX20,
    BrandFacebook20,
    FormBuilder20,
}

// Named exports matching Heroicons naming for easy replacement
export const PlusIcon = Plus16
export const MagnifyingGlassIcon = Search16
export const EllipsisVerticalIcon = DotsVertical16
export const ChevronUpIcon = ChevronUp16
export const ChevronDownIcon = ChevronDown16
export const UserCircleIcon = UserCircle16
export const ShieldCheckIcon = ShieldCheck16
export const LightBulbIcon = Bulb16
export const ArrowRightStartOnRectangleIcon = Logout16
export const ArrowDownIcon = ArrowDown16
export const SwitchVerticalIcon = SwitchVertical16
export const CodeDesignBrandIcon = CodeDesignBrandIcon16
export const LastUpdatedIcon = LastUpdated16
export const SparkleIcon = Sparkle16
export const SparkleWhiteIcon = SparkleWhite16

// 20px versions
export const DocumentTextIcon = FileText20
export const ChartBarIcon = ChartBar20
export const EyeIcon = Eye20
export const HomeIcon = Home20
export const UserGroupIcon = Users20
export const DocumentDuplicateIcon = Copy20
export const CreditCardIcon = CreditCard20
export const Cog6ToothIcon = Settings20
export const AcademicCapIcon = School20
export const NewspaperIcon = News20
export const PuzzlePieceIcon = Puzzle20
export const GlobeAltIcon = Globe20
export const RectangleGroupIcon = Layout20
export const ChatBubbleBottomCenterTextIcon = MessageCircle20
export const UsersIcon = Users20
export const PhotoIcon = Photo20
export const CpuChipIcon = CPU20
export const BellIcon = Bell20
export const FormBuilderIcon = FormBuilder20
export const TrelloIcon = trello20
export const ZapierIcon = zapier20
export const StripeIcon = stripe20
export const SlackIcon = slack20
export const AirtableIcon = airtable20
export const NotionIcon = notion20
export const GmailIcon = gmail20
export const GsheetIcon = gsheet20
export const WordpressIcon20 = wordpress20
export const EmptyStateIcon = EmptyState20
export const CrownIcon = Crown16
export const GreenTickIcon = GreenTick20
export const RefreshIcon = Refresh20
export const BarChartIcon = BarChart20
// Menu icons
export const MenuIcon = Menu16
export const XIcon = X16
export const SixDotsIcon = SixDots16
export const CheckBadgeIcon = CheckBadge16
export const GoogleIcon = GoogleIcon16
export const MoreIcon = MoreIcon16
export const DevicesIcon = DevicesIcon16
export const CodeBracketIcon = CodeBracket20
export const GoogleGIcon = BrandGoogleG20
export const BrandXIcon = BrandX20
export const FacebookIcon = BrandFacebook20
export const GoogleIcon20 = BrandGoogle20

// 24px versions
export const AIWebsiteBuilderIcon = AIWebsiteBuilder24
export const AIWritingToolsIcon = AIWritingTools24
export const AIWebsiteLibraryIcon = AIWebsiteLibrary24
export const DraftGenerationsIcon = DraftGenerations24
export const SeoAuditIcon = SeoAudit24
export const GoogleCalendarIcon = GoogleCalendar24
export const GoogleMeetIcon = GoogleMeet24
export const MicrosoftOutlookIcon = MicrosoftOutlook24
export const MicrosoftTeamsIcon = MicrosoftTeams24
export const ZoomIcon = Zoom24
export const BranchIcon = Branch24

//imgs
export { DefaultFavicon }
